
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";
import CheckboxV2 from "@/app/ui/components/check-box-v2/index.vue";
import PickupTimePopover from "./PickupTimePopover.vue";
import TimeSlotChip from "./TimeSlotChip.vue";
import { RegularDayKey, RegularTimeSlot } from "./schedule-types";
import { addOneHour } from "./schedule-utils";

class Props {
  day = prop<RegularDayKey>({
    required: true,
    type: String as PropType<RegularDayKey>
  });
  dayLabel = prop<string>({ required: true, type: String });
  checked = prop<boolean>({ default: false, type: Boolean });
  slots = prop<RegularTimeSlot[]>({
    default: () => [],
    type: Array as PropType<RegularTimeSlot[]>
  });
  enabled = prop<boolean>({ default: false, type: Boolean });
  popoverOpen = prop<boolean>({ default: false, type: Boolean });
  maxSlots = prop<number>({ default: 3, type: Number });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
}

@Options({
  components: {
    CheckboxV2,
    PickupTimePopover,
    TimeSlotChip
  },
  emits: ["update:checked", "update:slots", "open-add-time", "close-popover"]
})
export default class DayScheduleRow extends Vue.with(Props) {
  selectedStart = "";

  get controlsDisabled(): boolean {
    return !this.enabled || !this.checked;
  }

  get addTimeDisabled(): boolean {
    return this.controlsDisabled || this.slots.length >= this.maxSlots;
  }

  openAddTime(): void {
    if (!this.addTimeDisabled) this.$emit("open-add-time");
  }

  onPopoverVisibility(value: boolean): void {
    if (!value) this.$emit("close-popover");
  }

  closePopover(): void {
    if (this.popoverOpen) this.$emit("close-popover");
  }

  addSlot(start: string): void {
    if (this.slots.length >= this.maxSlots) return;
    if (this.slots.some((slot) => slot.start === start)) return;

    const newSlots = [
      ...this.slots,
      { start, end: addOneHour(start) }
    ].sort((a, b) => a.start.localeCompare(b.start));

    this.$emit("update:slots", newSlots);
  }

  removeSlot(index: number): void {
    if (this.controlsDisabled) return;
    this.$emit(
      "update:slots",
      this.slots.filter((_, slotIndex) => slotIndex !== index)
    );
  }
}
